import { useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { Routes, Route, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

//  All Top Bar And Side Bar
import Topbar from "./NavigationBar/Infinite_NavigationBar/Topbar";
import MemTopbar from "./NavigationBar/Members_NavigationBar/MemberTopBar";
import Sidebar from "./NavigationBar/Infinite_NavigationBar/Sidebar";
import MemberSidebar from "./NavigationBar/Members_NavigationBar/MemberSideBar";
import AdminSidebar from "./NavigationBar/Admin_NavigationBar/AdminSidebar";
import AdminTopbar from "./NavigationBar/Admin_NavigationBar/AdminTopbar";
import ShraddhaMobileMenuBar from "./NavigationBar/Members_NavigationBar/MobileMenuBar";

// All Parent Routes
import AuthRoutes from "./AllRoutes/AuthRoutes";
import AdminRoutes from "./AllRoutes/AdminRoutes";
import MemberRoutes from "./AllRoutes/MemberRoutes";
import InfiniteRoutes from "./AllRoutes/InfiniteRoutes";

function App() {
  const [theme, colorMode] = useMode();
  const location = useLocation();
  const navigate = useNavigate();

  const isMobileView = useMediaQuery("(max-width: 900px)");


  const isAdminPage = location.pathname.startsWith("/Admin");

  const memberPaths = location.pathname.startsWith("/Member");

  const isInfintePage = location.pathname.startsWith("/Infinite");

  // =================================

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/Auth/");
    }
  }, [location.pathname, navigate]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <main className="content">
            {/* Topbar For Infinite  */}
            {isInfintePage && <Topbar />}

            {/* Tobar for Menbers  */}
            {memberPaths && <MemTopbar />}

            {/* Topbar for Admin */}
            {isAdminPage && <AdminTopbar />}

            {/* Topbar for mobile  */}
            {isMobileView && memberPaths && <ShraddhaMobileMenuBar />}

            {/* {isGauest && <GauestTopbar />} */}

            <div className="layout">
              {/* Sidebar fo Infinite */}
              {(isInfintePage && <Sidebar />) || isMobileView}

              {/* sidebar for member */}
              {memberPaths && !isMobileView && <MemberSidebar />}

              {/* Sidebar for Admin */}
              {isAdminPage && <AdminSidebar />}

              {/* Sidebar for Gauest */}
              {/* {(isGauest && <GauestSidebar />) || isMobileView} */}

              {/* Routes for the application */}
              <div className="route-container">
                <Routes>
                  <Route path="/Admin/*" element={<AdminRoutes />} />
                  <Route path="/Member/*" element={<MemberRoutes />} />
                  <Route path="/Auth/*" element={<AuthRoutes />} />
                  <Route path="/Infinite/*" element={<InfiniteRoutes />} />
                </Routes>
              </div>
            </div>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;

//  document.addEventListener('contextmenu', (e) => e.preventDefault());